// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2N_Ul","footer":"ModalError_footer__1xjRu"};